import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import * as YouTube from "simple-youtube-api";

@Injectable()
export class YouTubeService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  videoUrl = "http://youtube.com";
  youtube = new YouTube("AIzaSyBO8l-bmZObRyf3fw4XAIEkqjf6qVPCptg");

  constructor(private httpClient: HttpClient) {}

  getPlaylist(videoId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.youtube
        .getPlaylist(`https://www.youtube.com/playlist?list=${videoId}`)
        .then((playlist) => {
          resolve(playlist);
        })
        .catch(console.log);
    });
  }
  // console.log(`The playlist's title is ${playlist.title}`);
  // playlist.getVideos()
  //     .then(videos => {
  //         console.log(`This playlist has ${videos.length === 50 ? '50+' : videos.length} videos.`);
  //     })
  //     .catch(console.log);

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
